import React from 'react'

import { Image, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import moment from 'moment'

import SmallLogo from '../../components/SmallLogo'
import ActiveStatus from '../../components/ActiveStatus';

import Styles from './HomeScreen.module.scss'

const HomeScreen = () => {

  const signHandler = () => {
    window.location.href = "https://beyondthewhiteboard.com/earned/challenges/8"
  }

  const isClosed = () => {
    return moment('2022-05-01 23:59:59-05:00').isBefore(moment());
  }

  return (
    <>
      <div className={Styles.poster}></div>

      <div className={Styles.container}>
        <div className={Styles.right}>
          <div className={Styles.content}>
            <h2>"Wedgewood"</h2>
            <h3>Challenge details</h3>
            <p>July 21 at 6am EST - July 24 at 6pm EST</p>
            <ActiveStatus />
            {isClosed() &&
              <br/>
            }
            {/*<SmallLogo topTitle='Charity' className={Styles.charity} imageName="charity" />
            <p>Formerly known as Steve’s Club National Program, Forging Youth Resilience (FYR) is a member-based 501(c)(3) nonprofit organization that partners with fitness facilities nationwide to bring fitness, nutrition, and mentorship to youth who otherwise would not have access to these services. </p>*/}
            {!isClosed() &&
              <div className={Styles.action}>
                <Button
                  variant='primary'
                  className={Styles.btn}
                  onClick={signHandler}
                >
                  Sign up
                </Button>
              </div>
            }

            <div className={Styles.textBox}>
              <h3>Price</h3>
              <p className={Styles.light}>
                <span>$20</span>
              </p>
            </div>

            <div className={Styles.textBox}>
              <h3>Workout description</h3>
              <p>3 rounds for time:</p>
              <p>33 Toes-to-bar</p>
              <p>22 Thrusters</p>
              <p>5 Rope Climbs</p>
              <p></p>
              <p>Time cap: 16 mins</p>
            </div>

            <div className={[Styles.textBox, Styles.division].join(' ')}>
              <h3>Divisions</h3>
              <p>Rx'd Male</p>
              <p>Rx'd Female</p>
              <p>Intermediate Male</p>
              <p>Intermediate Female</p>
            </div>
            
            <div className={Styles.pdfs}>
              <p><a target="_blank" href="https://s3.amazonaws.com/media.btwb.co/Competitions/PRVN/prvn-challenges-wedgewood/wedgewood-rules.pdf">Rules & Video Submission Guidelines</a></p>
            </div>

            <div className={[Styles.textBox, Styles.badge].join(' ')}>
              <h3>PRVN CHALLENGE BADGE</h3>
              <div className={Styles.icon}></div>
              <p>An exclusive btwb app badge for the completion of the PRVN Challenge.</p>
            </div>

            <div className={[Styles.textBox, Styles.contact].join(' ')}>
              <h3>Contact</h3>
              <a href='mailto:support@btwb.com'>support@btwb.com</a>
            </div>
          </div>
        </div>

        <div className={Styles.left}>
          <div className={Styles.content}>
            <p>Welcome to the PRVN Fitness, Benchmark Challenge presented by btwb. This is a global competition available for all athletes of all abilities to sign up to and to showcase their fitness. This challenge is about testing yourself and giving the entire CrossFit Community of our sport an opportunity to complete the same benchmark workout that our Elite PRVN Athletes use as a benchmark to test their training.</p>

            <p>
              <a href="https://beyondthewhiteboard.com/earned/challenges/8" target="_blank" noopener>
                <Button className={Styles.sign} variant='primary'>SIGN UP</Button>
              </a>
            </p>
            <div className={Styles.howBlock}>
              <h3>How it works</h3>
              <ul>
                <li>Register using the Sign Up button</li>
                <li>Review the rules and video submission guidelines</li>
                <li>Do the workout</li>
                <li>Log your score to btwb & attach the videos to be eligible to win major prizes</li>
                <li>Await a judging team member's ruling</li>
                <li>Receive your challenge badge</li>
              </ul>
              <p>Scores & videos need to be completely finished uploading no later than Sunday, July 24th, 2022 @ 6pm EST. Be sure to allow sufficient time to submit your scores & upload your videos.
              </p>
            </div>
            <h2>Prizes</h2>
            <h3>1ST PLACE:</h3>
            <p>Rogue Fitness Gift Voucher</p>
            <h3>2ND & 3RD PLACE:</h3>
            <p>Code for the purchase of a free eBook & PRVN shirt</p>

            {/*<img className={Styles.shirtImage} src="https://s3.amazonaws.com/media.btwb.co/Competitions/PRVN/prvn60_open_primer/shirts_transparent2.png" />*/}

            <h2>Video Verification</h2>
            <div className={Styles.youtube}>
              <p>If you’re interested in some of the cool prizes on offer, you MUST submit a video for this challenge event. Please refer to the <a href="https://s3.amazonaws.com/media.btwb.co/Competitions/PRVN/prvn-challenges-wedgewood/wedgewood-rules.pdf" target="_blank" noopener>official rules & standards</a> and the sample video below to make sure your videos meet the established guidelines.</p>
              <div className={Styles.video}><iframe width="560" height="315" src="https://www.youtube.com/embed/vnkqHMIKb9Y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
            {/*<h2>Give Back To Your Gym</h2>
            <p>Some of the best places are independently owned gyms. We love their unique character and cultures. These are places where we set personal records and escape to when we need to de-stress. PRVN Fitness wants to honor the good work CrossFit Affiliates do throughout the world by giving back to them. Part of the registration fee will donate money towards your personal affiliate to thank them. Athletes and Gyms interested in participating can get <a href="https://btwb.blog/2021/07/01/fitness-communities-discover-new-revenue-streams/">more information here</a>.  
            </p>*/}
            {/*<div className={Styles.video}>
              <button className={Styles.play}></button>
              <Image src='./images/video_bg.png' fluid className={Styles.big} />
            </div>*/}
            <div className={Styles.cellar}>
              {/*<SmallLogo topTitle='Charity' className={Styles.charity} imageName="charity" />
              <p>For every shirt purchased a tree will be planted.</p>*/}

              <div className={[Styles.textBox, Styles.badge].join(' ')}>
                <h3>PRVN CHALLENGE BADGE</h3>
                <div className={Styles.icon}></div>
                <p>An exclusive btwb app badge for the completion of the PRVN Challenge.</p>
              </div>

              <div className={[Styles.textBox, Styles.contact].join(' ')}>
                <h3>Contact</h3>
                <a href='mailto:support@btwb.com'>support@btwb.com</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HomeScreen
